import { DomainModel } from "@app/domain/models/domain.model"

export const trackById = <T extends DomainModel>(_index: number, { id }: T): T['id'] => id;

export const trackByIndex = (index: number) => index;

